module.exports = __webpack_public_path__ + "img/22.609969ae.png";